import { render, staticRenderFns } from "./AddDisposal.vue?vue&type=template&id=41e0be36"
import script from "./AddDisposal.vue?vue&type=script&lang=js"
export * from "./AddDisposal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports